import { render, staticRenderFns } from "./AssessmentPoints.vue?vue&type=template&id=72a4bae6&scoped=true&"
import script from "./AssessmentPoints.vue?vue&type=script&lang=js&"
export * from "./AssessmentPoints.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentPoints.vue?vue&type=style&index=0&id=72a4bae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4bae6",
  null
  
)

export default component.exports